import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import HelpersMixin from '@rogues/shared/mixins/helpers';
import CoreMixin from '@nodes/mixins/Core';
import { YSlideshow, YCounter } from '@rogues/index';
import { YSlide, YImage, YBadge } from '@components/index';
import Props from './props';

@Component({
    components: {
        YSlide,
        YImage,
        YBadge,
        YCounter,
        YSlideshow,
    },
})

/**
 * @name SpecialSale
 */
export default class SpecialSale extends Mixins(HelpersMixin, CoreMixin, HybridMixin, Props) {
    posts: Array<object> = [];
    metadata: Array<object> = [];
    slideshowConfigs: {[k: string]: any} = {
        nav           : 10,
        height        : 'auto',
        pagination    : 10,
        paginationNoBg: true,
        color         : 'body',
        slidesPerView : 1,
        spaceBetween  : 24,
        leftArrow     : true,
    }

    /**
     * Return list items
     *
     * @returns {Array}
     */
    get postsList(): Array<any> {
        return this.posts && this.posts.length ? this.posts : this.getValue('items');
    }

    /**
     * Calculator Percent Discount
     *
     * @param {*} item
     * @returns {number | string}
     */
    discountPercent(item): number | string {
        const val = (
            (
                (item.ware_original_price - item.ware_sale_price)
                / item.ware_original_price
            )
                * 100);
        // eslint-disable-next-line no-nested-ternary
        return val.toFixed(1)?.toString()?.split('.')[1] === '0'
            ? Math.round(val) : Math.round(val) > 1
                ? Math.round(val) : val.toFixed(1);
    }

    /**
     * Fetch Data
     */
    fetchItems() {
        this.$wait.start(`loading-campaign-${this.getValue('endpoint.params.campaign')}`);
        const api: {[k: string]: any} = {
            service: this.getObject('endpoint', 'service') || 'Content',
            name   : this.getObject('endpoint', 'name') || 'postList',
            params : this.getObject('endpoint', 'params'),
        };
        this.$services[api.service][api.name]({
            including: ['title', 'image', 'ware_sale_price', 'ware_original_price', 'campaign_ends_at', 'url_encode'],
            ...api.params,
        }).then((response: { data: { results: object[] | Array<any>; metadata: object[]; }; }) => {
            this.posts = response.data.results;
            this.metadata = response.data.metadata;
            if (!response.data.results.length) {
                this.$parent.$emit('empty', 0);
            }
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end(`loading-campaign-${this.getValue('endpoint.params.campaign')}`);
        });
    }

    /**
     * @inheritdoc
     */
    created() {
        if (!(this.getValue('items') && this.getValue('items').length)) {
            this.fetchItems();
        }
    }
}
